/* product-variant-sync.js  – expects `window.productData` to be populated beforehand */

function initVariantSync() {
  
  if (!window.productData || !window.productData.variants?.length) {
    return;
  }
  

  const { optionNames, variants } = window.productData;

  /* ---------- helpers ---------- */
  
  function updateColorSwatchLinks(currentSize) {
    
    const colorSwatchLinks = document.querySelectorAll('.color-swatch-link');
    
    colorSwatchLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href) {
        const url = new URL(href, window.location.origin);
        const oldSize = url.searchParams.get('size');
        
        // Update or add size parameter
        if (currentSize) {
          url.searchParams.set('size', currentSize);
        }
        
        // Update the href attribute
        link.setAttribute('href', url.toString());
      }
    });
  }
  const getIdx = label =>
    optionNames.findIndex(o => o.toLowerCase() === label.toLowerCase());

  const sizeIdx  = getIdx('size');
  const colorIdx = getIdx('color');
  const styleIdx = getIdx('style');
  
  
  // For products without color/size options, use the first option as the media-triggering option
  const firstOptionIdx = 0;

  // Color mapping to handle UI display names vs actual variant option names
  const mapColorName = (uiColorName) => {
    const colorMap = {
      'White/Pink': 'Light Pink',
      'White Pink': 'Light Pink',
      'White-Pink': 'Light Pink'
    };
    return colorMap[uiColorName] || uiColorName;
  };

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ---------- add-to-cart CSS hook management ---------- */
  const addAddToCartHook = () => {
    const addToCartContainer = $('.product-info__add-to-cart');
    if (!addToCartContainer) return;

    // Find the parent product-info__block
    const productInfoBlock = addToCartContainer.closest('.product-info__block');
    if (!productInfoBlock) return;

    // Add CSS hook class if not already present
    if (!productInfoBlock.classList.contains('product-info__block--add-to-cart')) {
      productInfoBlock.classList.add('product-info__block--add-to-cart');
    }
  };

  /* ---------- product-personalizer sold-out state management ---------- */
  const updateProductPersonalizerState = (variant = null) => {
    const productPersonalizer = $('.product-personalizer');
    if (!productPersonalizer) return;

    let hasSoldOutLabel = false;

    // First, check if we have variant data and it's not available
    if (variant && !variant.available) {
      hasSoldOutLabel = true;
    } else {
      // Check checked inputs
      const checkedInputs = $$('input[data-option-name]:checked');
      checkedInputs.forEach(input => {
        const label = $(`label[for="${input.id}"]`);
        if (label && label.classList.contains('sold-out')) {
          hasSoldOutLabel = true;
        }
      });

      // Also check labels with is-selected class (for initial page load)
      if (!hasSoldOutLabel) {
        const selectedLabels = $$('label.opt-label.is-selected');
        selectedLabels.forEach(label => {
          if (label.classList.contains('sold-out')) {
            hasSoldOutLabel = true;
          }
        });
      }
    }

    // Add or remove class based on sold-out state
    if (hasSoldOutLabel) {
      productPersonalizer.classList.add('sold-out-selected');
    } else {
      productPersonalizer.classList.remove('sold-out-selected');
    }
  };

  const formatMoney = (cents) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  };

  /* ---------- price display ---------- */
  const updatePriceDisplay = (variant) => {
    const priceContainer = $('.price');
    if (!priceContainer) return;

    // Skip price updates for featured collections - Liquid handles this correctly
    const isFeaturedCollection = priceContainer.closest('.featured-collection-container') || 
                                priceContainer.closest('[class*="featured-collection"]') ||
                                window.location.pathname === '/';
    
    if (isFeaturedCollection) {
      // For featured collections, don't interfere with Liquid-rendered prices
      return;
    }

    // Check if this is app-replaced content (simplified structure)
    const hasPriceDefault = priceContainer.querySelector('.price__default');
    const isAppReplaced = !hasPriceDefault && priceContainer.textContent.trim().match(/^\$[\d,]+\.?\d*$/);

    if (isAppReplaced) {
      // Clear the app-replaced content
      priceContainer.innerHTML = '';

      // Rebuild proper structure
      const priceDefaultDiv = document.createElement('div');
      priceDefaultDiv.className = 'price__default';

      const priceElement = document.createElement('span');
      priceElement.className = 'strong';
      priceElement.innerHTML = formatMoney(variant.price);

      priceDefaultDiv.appendChild(priceElement);

      // Add compare-at price if needed
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const compareAtElement = document.createElement('s');
        compareAtElement.className = 'price__was';
        compareAtElement.innerHTML = formatMoney(variant.compare_at_price);
        priceDefaultDiv.appendChild(compareAtElement);
      }

      priceContainer.appendChild(priceDefaultDiv);

      // Ensure CSS is applied immediately
      priceDefaultDiv.style.display = 'flex';
      priceDefaultDiv.style.alignItems = 'baseline';
      priceDefaultDiv.style.gap = '0.5rem';

    } else {
      // For Liquid-rendered content, DON'T override the prices
      // The Liquid template already selected the correct variant with proper pricing
      // Only update if there's a mismatch between expected and actual prices
      
      let currentPriceElement = priceContainer.querySelector('.price__default .strong');
      let compareAtPriceElement = priceContainer.querySelector('.price__default .price__was');
      
      if (currentPriceElement) {
        // Check if the displayed price matches the variant price
        const displayedPriceText = currentPriceElement.textContent.trim();
        const expectedPriceText = formatMoney(variant.price);
        
        // Only update if there's a mismatch (e.g., app interference)
        if (displayedPriceText !== expectedPriceText) {
          currentPriceElement.innerHTML = expectedPriceText;
        }
      }

      // Handle compare-at price
      if (compareAtPriceElement) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const displayedCompareText = compareAtPriceElement.textContent.trim();
          const expectedCompareText = formatMoney(variant.compare_at_price);
          
          // Only update if there's a mismatch
          if (displayedCompareText !== expectedCompareText) {
            compareAtPriceElement.innerHTML = expectedCompareText;
          }
        compareAtPriceElement.style.display = '';
      } else {
        compareAtPriceElement.style.display = 'none';
        }
      }
    }

    // INTERCEPT DOM METHODS: Override methods that external scripts might use to modify price
    if (!window.priceInterceptionSetup) {
      window.priceInterceptionSetup = true;
      
      const priceContainer = $('.price');
      if (priceContainer) {
        // Store original methods
        const originalInnerHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
        const originalTextContent = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
        const originalReplaceWith = Element.prototype.replaceWith;
        
        // Override innerHTML setter
        Object.defineProperty(priceContainer, 'innerHTML', {
          set: function(value) {
            // Check if this is removing the price structure
            if (typeof value === 'string' && value.match(/^\$[\d,]+\.?\d*$/)) {
              return; // Block the change
            }
            
            // Allow the change
            originalInnerHTML.set.call(this, value);
          },
          get: originalInnerHTML.get
        });
        
        // Override textContent setter
        Object.defineProperty(priceContainer, 'textContent', {
          set: function(value) {
            // Check if this is removing the price structure
            if (typeof value === 'string' && value.match(/^\$[\d,]+\.?\d*$/)) {
              return; // Block the change
            }
            
            // Allow the change
            originalTextContent.set.call(this, value);
          },
          get: originalTextContent.get
        });
        
        // Override replaceWith method
        Element.prototype.replaceWith = function(...nodes) {
          if (this === priceContainer) {
            // Check if this is replacing with simple text
            const newNode = nodes[0];
            if (newNode && newNode.nodeType === Node.TEXT_NODE && newNode.textContent.match(/^\$[\d,]+\.?\d*$/)) {
              return; // Block the change
            }
          }
          
          // Allow the change
          return originalReplaceWith.apply(this, nodes);
        };
        
        // Override removeChild method
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
          if (this === priceContainer && child.classList && child.classList.contains('price__default')) {
            return child; // Block the removal
          }
          
          // Allow the change
          return originalRemoveChild.call(this, child);
        };
      }
    }

    // Set up mutation observer to track HTML changes and rebuild when needed
    if (!window.priceMutationObserver) {
      window.priceMutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Check if price__was element was removed
            const priceWasElement = mutation.target.querySelector('.price__was');

            if (!priceWasElement && mutation.target.classList.contains('price')) {
              // Check if this is app-replaced content (simplified structure)
              const hasPriceDefault = mutation.target.querySelector('.price__default');
              const isAppReplaced = !hasPriceDefault && mutation.target.textContent.trim().match(/^\$[\d,]+\.?\d*$/);

              if (isAppReplaced) {
                // Get current variant data
                const currentVariant = window.ProductData?.variants?.find(v => v.id === window.ProductData?.selected_variant_id);
                if (currentVariant) {
                  // Clear the app-replaced content
                  mutation.target.innerHTML = '';

                  // Rebuild proper structure
                  const priceDefaultDiv = document.createElement('div');
                  priceDefaultDiv.className = 'price__default';

                  const priceElement = document.createElement('span');
                  priceElement.className = 'strong';
                  priceElement.innerHTML = formatMoney(currentVariant.price);

                  priceDefaultDiv.appendChild(priceElement);

                  // Add compare-at price if needed
                  if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
                    const compareAtElement = document.createElement('s');
                    compareAtElement.className = 'price__was';
                    compareAtElement.innerHTML = formatMoney(currentVariant.compare_at_price);
                    priceDefaultDiv.appendChild(compareAtElement);
                  }

                  mutation.target.appendChild(priceDefaultDiv);

                  // Ensure CSS is applied immediately
                  priceDefaultDiv.style.display = 'flex';
                  priceDefaultDiv.style.alignItems = 'baseline';
                  priceDefaultDiv.style.gap = '0.5rem';
                }
              }
            }
          }
        });
      });

      // Start observing the price container
      if (priceContainer && priceContainer.nodeType === Node.ELEMENT_NODE) {
        try {
          window.priceMutationObserver.observe(priceContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        } catch (error) {
        }
      } else {
      }
    }
  };

  /* ---------- variant change handler ---------- */
  const handleVariantChange = (variant) => {
    if (!variant) {
      return;
    }


    // Update the hidden variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    
    variantIdInputs.forEach(input => {
      input.value = variant.id;
    });

    // Only update URL on Product Detail Pages (PDPs), not on homepage or other pages
    const isProductPage = window.location.pathname.includes('/products/');
    if (isProductPage) {
      // Update URL with both variant and size parameters
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('variant', variant.id);

      // Update size parameter to match the actual selected size (could be "Size" or "Style")
      const sizeOptionIdx = sizeIdx >= 0 ? sizeIdx : styleIdx;
      if (sizeOptionIdx >= 0 && variant.options[sizeOptionIdx]) {
        currentUrl.searchParams.set('size', variant.options[sizeOptionIdx]);
      }

      window.history.replaceState(null, '', currentUrl.toString());
    }

    // Update color swatch links to include current size parameter
    if (sizeOptionIdx >= 0) {
      updateColorSwatchLinks(variant.options[sizeOptionIdx]);
    }

    // Update add to cart button
    const addToCartBtn = $('[name="add"], .product-form__cart-submit');
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      if (!variant.available) {
        addToCartBtn.textContent = 'Sold Out';
      } else {
        addToCartBtn.textContent = 'Add to Cart';
      }
    }

    // Update color text display
    const colorTextElement = $('.js-color-text');
    if (colorTextElement && variant.options[colorIdx]) {
      colorTextElement.textContent = variant.options[colorIdx];
    }

    // Update size text display
    const sizeTextElement = $('.js-size-text');
    if (sizeTextElement && variant.options[sizeIdx]) {
      sizeTextElement.textContent = variant.options[sizeIdx];
    }

    // Update style text display
    const styleTextElement = $('.js-style-text');
    if (styleTextElement && variant.options[styleIdx]) {
      styleTextElement.textContent = variant.options[styleIdx];
    } else {
    }

    // Sync radio button states with variant options
    variant.options.forEach((optionValue, optionIndex) => {
      const optionName = optionNames[optionIndex];
      if (optionName) {
        const allInputsForOption = document.querySelectorAll(`input[data-option-name="${optionName}"]`);
        allInputsForOption.forEach(radioInput => {
          const isChecked = (radioInput.value === optionValue);
          radioInput.checked = isChecked;
          
          // Update the label classes to match the checked state
          const label = document.querySelector(`label[for="${radioInput.id}"]`);
          if (label) {
            if (isChecked) {
              label.classList.add('is-selected');
            } else {
              label.classList.remove('is-selected');
            }
          }
        });
      }
    });

    // Product title should not be updated with variant information
    // Both standard and combined products keep their original titles

    // Update price display
    updatePriceDisplay(variant);

    // Add CSS hooks to product-info__block elements
    addAddToCartHook();

    // Update product-personalizer state based on sold-out labels
    updateProductPersonalizerState(variant);

    // Trigger media gallery if variant has featured media
    if (variant.featured_media) {
      const productSection = $('.js-product');
      const mediaGallery = $('.media-gallery, .product-media, .product__media');
      
      
      // Try multiple selectors for media gallery
      const mediaTarget = mediaGallery || productSection || document;
      
      
      if (mediaTarget) {
        // Dispatch both events to ensure media gallery updates
        mediaTarget.dispatchEvent(new CustomEvent('on:variant:change', {
          detail: {
            variant: variant,
            product: window.productData
          },
          bubbles: true
        }));
        
        mediaTarget.dispatchEvent(new CustomEvent('on:variant:change:media-only', {
          detail: {
            variant: variant,
            product: window.productData
          },
          bubbles: true
        }));
        } else {
      }
    } else {
    }
  };

  /* ---------- event listeners ---------- */
  
  // Handle direct input changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[data-option-name]')) {
      syncVariantFromInputs();
    }
  });
  
  // Handle color swatch clicks
  document.addEventListener('variant:sync', function(e) {
    syncVariantFromInputs();
  });

  // Handle clicks on variant labels (both enabled and disabled)
  document.addEventListener('click', function(e) {
    // Only log variant-related clicks to reduce noise
    if (e.target.tagName === 'LABEL' || e.target.closest('label') || e.target.classList.contains('opt-label') || e.target.closest('.opt-label')) {
    }
    
    const variantSelectors = 'label[for*="style-"], label[for*="color-"], label[for*="size-"], .color-swatch-link';
    
    // Check if click is on the label or a child element of the label
    const clickedLabel = e.target.matches(variantSelectors) ? e.target : e.target.closest(variantSelectors);
    
    // Handle sold-out label clicks for product-personalizer state
    if (clickedLabel && clickedLabel.tagName === 'LABEL') {
      // Use setTimeout to allow the input state to update first
      setTimeout(() => {
        updateProductPersonalizerState();
      }, 0);
    }
    
    if (clickedLabel) {
      // Use the label element instead of e.target
      const targetElement = clickedLabel;
      
      let variantValue, optionName;
      
      // Handle color swatch links differently
      if (targetElement.classList.contains('color-swatch-link')) {
        
        // Check if this color swatch navigates to a different product
        const href = targetElement.getAttribute('href');
        if (href) {
          const targetUrl = new URL(href, window.location.origin);
          const currentPath = window.location.pathname;
          const targetPath = targetUrl.pathname;
          
          if (targetPath !== currentPath) {
            return; // Let the browser handle the navigation
          }
        }
        
        variantValue = targetElement.getAttribute('data-value');
        optionName = 'Color';
      } else {
        // Handle regular label clicks
        const label = targetElement;
        const inputId = label.getAttribute('for');
        const input = document.getElementById(inputId);
        
        if (input) {
          variantValue = input.value;
          optionName = input.dataset.optionName;
        } else {
          return;
        }
      }
      
      if (variantValue && optionName) {
        
        // Get currently selected options to preserve them
        const currentlySelectedOptions = {};
        optionNames.forEach((name, index) => {
          const selectedInput = document.querySelector(`input[data-option-name="${name}"]:checked`);
          if (selectedInput) {
            currentlySelectedOptions[name] = selectedInput.value;
          } else {
            
            // For Color option, try to get it from the active color swatch or URL
            if (name === 'Color') {
              const activeColorSwatch = document.querySelector('.color-swatch-link.is-selected');
              if (activeColorSwatch) {
                const colorValue = activeColorSwatch.textContent.trim();
                currentlySelectedOptions[name] = colorValue;
              } else {
                // Try to get color from URL parameter
                const urlParams = new URLSearchParams(window.location.search);
                const colorFromUrl = urlParams.get('color');
                if (colorFromUrl) {
                  currentlySelectedOptions[name] = colorFromUrl;
                }
              }
            }
          }
        });
        
        // Override with the clicked option
        currentlySelectedOptions[optionName] = variantValue;
        
        // Find the variant that matches all current selections
        const matchingVariant = variants.find(variant => {
          const matches = optionNames.every((name, index) => {
            const expectedValue = currentlySelectedOptions[name];
            const variantValue = variant.options[index];
            const isMatch = expectedValue && variantValue === expectedValue;
            return isMatch;
          });
          return matches;
        });
        
        if (matchingVariant) {
          
          // Update all radio button states to match the found variant
          optionNames.forEach((name, index) => {
            const expectedValue = matchingVariant.options[index];
            const allInputsForOption = document.querySelectorAll(`input[data-option-name="${name}"]`);
            allInputsForOption.forEach(radioInput => {
              const isChecked = (radioInput.value === expectedValue);
              radioInput.checked = isChecked;
              
              // Update the label classes to match the checked state
              const label = document.querySelector(`label[for="${radioInput.id}"]`);
              if (label) {
                if (isChecked) {
                  label.classList.add('is-selected');
                } else {
                  label.classList.remove('is-selected');
                }
              }
            });
          });
          
          // Trigger variant change
          handleVariantChange(matchingVariant);
        } else {
          variants.forEach(variant => {
          });
        }
      }
    }
  });
  
  // Function to sync variant based on current input selections
  function syncVariantFromInputs() {
    
    const selectedOptions = {};
    const checkedInputs = $$('input[data-option-name]:checked');
    
    checkedInputs.forEach(input => {
      selectedOptions[input.dataset.optionName] = input.value;
    });
    

    // Find the matching variant
    let matchingVariant = null;
    for (const variant of variants) {
      let matches = true;
      
      Object.keys(selectedOptions).forEach(optionName => {
        const optionIndex = optionNames.indexOf(optionName);
        if (optionIndex >= 0) {
          const variantOptionValue = variant.options[optionIndex];
          if (variantOptionValue !== selectedOptions[optionName]) {
            matches = false;
          }
        }
      });
      
      if (matches) {
        matchingVariant = variant;
        break;
      }
    }


    if (matchingVariant) {
      handleVariantChange(matchingVariant);
    } else {
    }
  }

  // Initialize with current variant
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get('variant');
  const urlSize = urlParams.get('size');
  
  
  let currentVariant;
  
  if (urlVariantId) {
    currentVariant = variants.find(v => v.id == urlVariantId);
  } else {
    const formVariantId = parseInt($('input[name="id"]')?.value);
    currentVariant = variants.find(v => v.id === formVariantId);
  }
  
  
  // If URL has a size parameter that doesn't match the variant, find the correct variant
  const sizeOptionIdx = sizeIdx >= 0 ? sizeIdx : styleIdx;
  if (urlSize && currentVariant && sizeOptionIdx >= 0 && currentVariant.options[sizeOptionIdx] !== urlSize) {
    
    // Find variant that matches the URL size and the same color
    const colorValue = currentVariant.options[colorIdx];
    const correctVariant = variants.find(v => 
      v.options[colorIdx] === colorValue && v.options[sizeOptionIdx] === urlSize
    );
    
    if (correctVariant) {
      currentVariant = correctVariant;
    } else {
    }
  }
  
  if (currentVariant) {
    handleVariantChange(currentVariant);
  }

  // Initial load: add CSS hooks to product-info__block elements
  addAddToCartHook();

  // Initial load: check selected labels and update product-personalizer state
  // Call immediately and with delays to ensure it works even if DOM loads late
  updateProductPersonalizerState(currentVariant);
  
  setTimeout(() => {
    addAddToCartHook(); // Ensure hook is added even if DOM loads late
    updateProductPersonalizerState(currentVariant);
  }, 100);
  
  // Additional retry for very late-loading content
  setTimeout(() => {
    updateProductPersonalizerState(currentVariant);
  }, 500);
}


// Try to initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantSync);
} else {
  // DOM is already loaded, run immediately
  initVariantSync();
}